import { all, takeLatest, fork } from 'redux-saga/effects';
import { AppTypes } from './AppRedux';
import { startup, loadAppdata, loadPriceData } from './AppSaga';
import { AuthTypes } from './AuthRedux';
import { BookingTypes } from './BookingRedux';
import { initBookingFromClean, fetchBookingsData } from './BookingSaga';
import { ScheduleTypes } from './ScheduleRedux';
import {
  confirmRecurringStartDate,
  initRecurringBookingFromSubscription
} from './ScheduleSaga';
import {
  storeToken,
  clearToken,
  refreshAuthToken,
  loadUser,
  storeUser
} from './AuthSaga';
import { CleansTypes } from './CleansRedux';
import {
  loadMyCleansList,
  loadMyCleansOfMonth,
  loadCleanDetail,
  updateCleanDetail
} from './CleansSaga';
import { PropertyTypes } from './PropertyRedux';
import { loadAllProperties } from './PropertySaga';
import { SubscriptionTypes } from './SubscriptionRedux';
import { loadSubscriptions } from './SubscriptionSaga';
import { BillingHistoryTypes } from './BillingHistoryRedux';
import { loadBillingHistory } from './BillingHistorySaga';

import AnalyticsModule from './AnalyticsSaga';

/**
 * rootSaga
 */
export default function* root() {
  yield all([
    takeLatest(AppTypes.STARTUP, startup),
    takeLatest(AppTypes.SET_APP_DATA_LOAD_REQUEST, loadAppdata),
    takeLatest(AppTypes.SET_PRICE_DATA_LOAD_REQUEST, loadPriceData),
    takeLatest(AuthTypes.SET_LOGGED_IN, storeToken),
    takeLatest(AuthTypes.SET_LOGGED_OUT, clearToken),
    takeLatest(AuthTypes.SET_USER, storeUser),
    takeLatest(AuthTypes.SET_REFRESH_AUTH_REQUEST, refreshAuthToken),
    takeLatest(AuthTypes.SET_USER_LOAD_REQUEST, loadUser),
    takeLatest(BookingTypes.FETCH_BOOKINGS_DATA, fetchBookingsData),
    takeLatest(
      ScheduleTypes.SET_RECURRING_CONFIRM_START_DATE,
      confirmRecurringStartDate
    ),
    takeLatest(
      ScheduleTypes.INIT_RECURRING_BOOKING_FROM_SUBSCRIPTION,
      initRecurringBookingFromSubscription
    ),
    takeLatest(BookingTypes.INIT_BOOKING_FROM_CLEAN, initBookingFromClean),
    takeLatest(CleansTypes.SET_MY_CLEANS_LOAD_REQUEST, loadMyCleansList),
    takeLatest(
      CleansTypes.SET_MY_CLEANS_OF_MONTH_LOAD_REQUEST,
      loadMyCleansOfMonth
    ),
    takeLatest(CleansTypes.SET_MY_CLEAN_DETAIL_LOAD_REQUEST, loadCleanDetail),
    takeLatest(
      CleansTypes.SET_MY_CLEAN_DETAIL_UPDATE_REQUEST,
      updateCleanDetail
    ),
    takeLatest(PropertyTypes.SET_PROPERTIES_LOAD_REQUEST, loadAllProperties),
    takeLatest(
      SubscriptionTypes.SET_SUBSCRIPTION_LOAD_REQUEST,
      loadSubscriptions
    ),
    takeLatest(
      BillingHistoryTypes.SET_BILLING_HISTORY_LOAD_REQUEST,
      loadBillingHistory
    ),
    fork(AnalyticsModule)
  ]);
}
